import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es6.regexp.to-string';
import 'core-js/modules/es6.reflect.construct';
import 'core-js/modules/es6.function.name';
import _classCallCheck from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _inherits from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
import _possibleConstructorReturn from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== 'undefined' && o[Symbol.iterator] || o['@@iterator'];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === 'number') {
            if (it)
                o = it;
            var i = 0;
            var F = function F() {
            };
            return {
                s: F,
                n: function n() {
                    if (i >= o.length)
                        return { done: true };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null)
                    it.return();
            } finally {
                if (didErr)
                    throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/imagestyle/imagestyleui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { normalizeImageStyles } from './utils';
import '../../theme/imagestyle.css';
/**
 * The image style UI plugin.
 *
 * @extends module:core/plugin~Plugin
 */
var ImageStyleUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(ImageStyleUI, _Plugin);
    var _super = _createSuper(ImageStyleUI);
    function ImageStyleUI() {
        _classCallCheck(this, ImageStyleUI);
        return _super.apply(this, arguments);
    }
    _createClass(ImageStyleUI, [
        {
            key: 'localizedDefaultStylesTitles',
            get: /**
     * Returns the default localized style titles provided by the plugin.
     *
     * The following localized titles corresponding with
     * {@link module:image/imagestyle/utils~defaultStyles} are available:
     *
     * * `'Full size image'`,
     * * `'Side image'`,
     * * `'Left aligned image'`,
     * * `'Centered image'`,
     * * `'Right aligned image'`
     *
     * @returns {Object.<String,String>}
     */
            function get() {
                var t = this.editor.t;
                return {
                    'Full size image': t('Full size image'),
                    'Side image': t('Side image'),
                    'Left aligned image': t('Left aligned image'),
                    'Centered image': t('Centered image'),
                    'Right aligned image': t('Right aligned image')
                };
            }    /**
     * @inheritDoc
     */
        },
        {
            key: 'init',
            value: function init() {
                var editor = this.editor;
                var configuredStyles = editor.config.get('image.styles');
                var translatedStyles = translateStyles(normalizeImageStyles(configuredStyles), this.localizedDefaultStylesTitles);
                var _iterator = _createForOfIteratorHelper(translatedStyles), _step;
                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var style = _step.value;
                        this._createButton(style);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
            }    /**
     * Creates a button for each style and stores it in the editor {@link module:ui/componentfactory~ComponentFactory ComponentFactory}.
     *
     * @private
     * @param {module:image/imagestyle/imagestyleediting~ImageStyleFormat} style
     */
        },
        {
            key: '_createButton',
            value: function _createButton(style) {
                var _this = this;
                var editor = this.editor;
                var componentName = 'imageStyle:'.concat(style.name);
                editor.ui.componentFactory.add(componentName, function (locale) {
                    var command = editor.commands.get('imageStyle');
                    var view = new ButtonView(locale);
                    view.set({
                        label: style.title,
                        icon: style.icon,
                        tooltip: true,
                        isToggleable: true
                    });
                    view.bind('isEnabled').to(command, 'isEnabled');
                    view.bind('isOn').to(command, 'value', function (value) {
                        return value === style.name;
                    });
                    _this.listenTo(view, 'execute', function () {
                        return editor.execute('imageStyle', { value: style.name });
                    });
                    return view;
                });
            }
        }
    ], [{
            key: 'pluginName',
            get: /**
     * @inheritDoc
     */
            function get() {
                return 'ImageStyleUI';
            }
        }]);
    return ImageStyleUI;
}(Plugin);
/**
 * Returns the translated `title` from the passed styles array.
 *
 * @param {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>} styles
 * @param titles
 * @returns {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>}
 */
export {
    ImageStyleUI as default
};
function translateStyles(styles, titles) {
    var _iterator2 = _createForOfIteratorHelper(styles), _step2;
    try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var style = _step2.value;
            // Localize the titles of the styles, if a title corresponds with
            // a localized default provided by the plugin.
            if (titles[style.title]) {
                style.title = titles[style.title];
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally {
        _iterator2.f();
    }
    return styles;
}